import { makeStyles } from 'tss-react/mui';

interface StyleProps {
  isCompleted?: boolean;
  isSelected?: boolean;
}

/**
 * Common styles used by Variable components.
 */
export const useVariableStyles = makeStyles<StyleProps>()((theme, { isSelected }) => ({
  input: {
    background: theme.appColors.background,
    border: '1px solid transparent',
    boxSizing: 'border-box',
    minHeight: 32,
  },
  question: {
    fontSize: 14,
    marginBottom: theme.spacing(2),
  },
  variable: {
    '&:hover': {
      border: isSelected
        ? `1px solid ${theme.palette.primary.main}`
        : `1px solid ${theme.appColors.rule}`,
    },
    border: isSelected ? `1px solid ${theme.palette.primary.main}` : '1px solid transparent',
    borderRadius: 3,
    boxSizing: 'border-box',
    cursor: 'pointer',
    outline: 'none',
    padding: theme.spacing(1),
  },
}));

export const useStickyListStyles = makeStyles()(theme => ({
  collapseButton: {
    alignItems: 'center',
    boxSizing: 'border-box',
    color: theme.appColors.iconsType,
    display: 'flex',
    height: '100%',
    padding: theme.spacing(0, 2),
    width: '100%',
  },
  collapseContainer: {
    padding: theme.spacing(2, 1),
  },
  inputLabel: {
    ...theme.appTypography.fieldLabel,
    marginBottom: theme.spacing(1),
  },
  listRoot: {
    boxSizing: 'border-box',
    height: '100%',
    overflow: 'auto',
    position: 'relative',
    width: '100%',
  },
  listSubheaderText: {
    fontWeight: 600,
  },
  row: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
  stickyHeader: {
    backgroundColor: theme.palette.common.white,
    borderBottom: `1px solid ${theme.appColors.rule}`,
    boxSizing: 'border-box',
    height: 40,
    lineHeight: 40,
    padding: 0,
  },
  toggleList: {
    padding: 0,
  },
}));
